export const flowNodeStatus = [
    { label: "待处理", value: "waiting"},
    { label: "处理中", value: "processing"},
    { label: "处理完成", value: "completed"},
];
export const applyStatus = [
    { label: "废弃", value: "abandon"},
    { label: "数据异常", value: "verify_exception"},
    { label: "待提交", value: "wait_submit"},
    { label: "审核中", value: "auditing"},
    { label: "待付款", value: "wait_pay"},
    { label: "付款处理中", value: "paying"},
    { label: "付款失败", value: "pay_fail"},
    { label: "付款成功", value: "pay_success"},
    {label: "完成回单", value: "finished"}
];

export const applyStatusMap = applyStatus.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
}, {});

// 订单平台：1商城，2苹果，3淘宝，4天猫，5小红书，6抖音，7微信小商店，8线下收款
export const OrderPlatformList = [
    { label: "商城", value: "mall"},
    { label: "苹果", value: "apple"},
    { label: "淘宝", value: "tbm"},
    { label: "天猫", value: "tm"},
    { label: "小红书", value: "xhs"},
    { label: "抖音", value: "douyin"},
    { label: "微信小商店", value: "wx_shop"},
    { label: "线下收款", value: "offline_pay"},
];
export const OrderPlatformMap = OrderPlatformList.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
}, {});
// # 直接退款,学习币退款
export const RefundTypeList = [
    { label: "直接退款", value: "direct"},
    { label: "学习币退款", value: "coin"},
];
export const RefundTypeMap = RefundTypeList.reduce((acc, curr) => {
    acc[curr.value] = curr.label;
    return acc;
}, {});
// # 退款原因：1退学习币，2平台超期，3线下收款，4用户账号注销，5重复扣款，商城无订单,6其他原因无法线上退款
export const RefundReasonList = [
    { label: "退学习币", value: "refund_coin"},
    { label: "平台超期", value: "overdue"},
    { label: "线下收款", value: "offline_payment"},
    { label: "用户账号注销", value: "account_cancel"},
    { label: "重复扣款", value: "repeat_pay"},
    { label: "其他原因无法线上退款", value: "cannot_refund_online"},
    {label: "苹果支付（仅退款）", value: "apple_pay_only_refund"}
];
export const RefundReasonMap = RefundReasonList.reduce((acc, curr) => {
  acc[curr.value] = curr.label;
  return acc;
}, {});